import type {
  CollectionSustainabilityConfig,
  SustainabilityComponentInput,
} from "@repo/shared/types";
import {
  useSaveSustainability,
  useSustainabilityFlowInstanceValue,
} from "@/lib/hooks/use-flow-instances/use-sustainability";
import { SustainabilityWidget } from "../sustainability-widget";

type WizardSustainabilityProps = {
  instanceId: string;
  disabled: boolean;
  config: { style?: "none" | "border" | "box"; title?: string; description?: string };
  /** From the flow definition's portfolio collection (null = disabled). */
  sustainabilityConfig: CollectionSustainabilityConfig | null;
  language: string;
  hasValidationError?: boolean;
  /** QL-188 — group answering note; null for non-group clients. */
  groupNote?: string | null;
};

export function WizardSustainability({
  instanceId,
  disabled,
  config,
  sustainabilityConfig,
  language,
  hasValidationError,
  groupNote,
}: WizardSustainabilityProps) {
  const { inputData, isLoading: valueLoading } = useSustainabilityFlowInstanceValue(instanceId);
  const saveSustainability = useSaveSustainability(instanceId);

  const handleChange = (input: SustainabilityComponentInput) => {
    saveSustainability.mutate(input);
  };

  if (valueLoading) return null;

  return (
    <SustainabilityWidget
      sustainabilityConfig={sustainabilityConfig}
      inputData={inputData}
      onChange={handleChange}
      disabled={disabled}
      style={config.style}
      title={config.title}
      description={config.description}
      language={language}
      hasValidationError={hasValidationError}
      groupNote={groupNote}
    />
  );
}
